import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_lot_history_report_LotHistoryBreakdown_ByReceiving_Adjustment_Inspection_StatusChangeService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotId?: number }): 
  Promise<{ result: { Id?: number, MaterialId?: number, Tasks?: { Id?: number, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, CompletedDateTime?: string, GrossWeight?: number, NetWeight?: number, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, StatusId?: number, WarehouseId?: number, WeightUomId?: number, OperationCode?: { OperationTypeId?: number } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_lot_history_report_LotHistoryBreakdown_ByReceiving_Adjustment_Inspection_StatusChange/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, MaterialId?: number, Tasks?: { Id?: number, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, CompletedDateTime?: string, GrossWeight?: number, NetWeight?: number, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, StatusId?: number, WarehouseId?: number, WeightUomId?: number, OperationCode?: { OperationTypeId?: number } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_lot_history_report_LotHistoryBreakdown_ByReceiving_Adjustment_Inspection_StatusChange/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, MaterialId?: number, Tasks?: { Id?: number, ActualInventoryAmount?: number, ActualInventoryAmountPackId?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, CompletedDateTime?: string, GrossWeight?: number, NetWeight?: number, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, StatusId?: number, WarehouseId?: number, WeightUomId?: number, OperationCode?: { OperationTypeId?: number } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_lot_history_report_LotHistoryBreakdown_ByReceiving_Adjustment_Inspection_StatusChange/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
